import type { CardDetail } from "../../api/models";
import { ZoomImage } from "../../components/Lightbox";

export function EbayPanel({ card }: { card: CardDetail }) {
  const run = card.runs[0];
  const items = run?.ebayItems ?? [];
  return (
    <div className="panel">
      <h3>eBay visual search</h3>
      <p>
        <a href={card.ebaySearch} target="_blank" rel="noreferrer">
          Search eBay by the card's reading ↗
        </a>
      </p>
      {!run ? (
        <p className="muted">No runs yet.</p>
      ) : items.length === 0 ? (
        <p className="muted">
          {run.ebayDegraded
            ? `eBay visual search failed in run #${run.runId}: ${run.ebayDegraded}.`
            : run.ebayListings
              ? `Run #${run.runId} found ${run.ebayListings} listings but did not record them.`
              : `eBay visual search found nothing in run #${run.runId}.`}
        </p>
      ) : (
        <div className="ebay-items">
          {items.map((item, i) => (
            <div key={item.link ?? i} className="ebay-item">
              {item.image ? (
                <ZoomImage
                  className="catalog-thumb"
                  src={item.image}
                  beside={card.photoUrl}
                  alt={item.title}
                  loading="lazy"
                />
              ) : (
                <div className="catalog-thumb placeholder">no picture</div>
              )}
              <a href={item.link} target="_blank" rel="noreferrer" title={item.title}>
                {item.title || "listing"}
              </a>
              {item.epid && <span className="muted">epid {item.epid}</span>}
              {item.price?.value && (
                <span className="muted">
                  {item.price.value} {item.price.currency}
                </span>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
